<template>
  <span class="quote-pill">
    <FontAwesomeIcon :icon="['far', 'circle-info']" />
    {{
      $t(kind === "by-quote" ? "bulk_buy.by_quote" : "bulk_buy.manual_quote")
    }}
  </span>
</template>

<script setup lang="ts">
defineProps<{
  /**
   * "by-quote": the whole order is a custom (OTHER-mode) quote;
   * "manual-quote": no liquid market for this row, priced via RFQ.
   */
  kind: "by-quote" | "manual-quote";
}>();
</script>

<style scoped lang="scss">
// Ochre pill for price states quoted through an RFQ rather than automatically.
.quote-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: var(--phoenix-warning-bg-subtle);
  border: 1px solid var(--phoenix-warning-border-subtle);
  color: var(--phoenix-warning-text-emphasis);
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
</style>
